<template>
  <div class="myFont">
    <!-- 活动标题 -->
    <div v-wechat-title="'新仙剑丨师徒系统'"></div>
    <div :class="'mentoring-wrapper ' + (homeShow ? 'show_page' : '')">
      <div class="home-page" id="home-page">
        <div class="main">
          <div class="container">
            <div class="content-box">
              <!-- 首屏 -->
              <div :class="'logo ' + (isOpenCore ? 'fade_in_ani' : '')"></div>
              <div :class="'decoration_box ' + (isOpenCore ? 'open_ani' : '')">
                <div class="left">
                  <div class="butterfly butterfly_1"></div>
                  <div class="butterfly butterfly_2"></div>
                  <div class="butterfly butterfly_3"></div>
                </div>
                <div class="right">
                  <div class="butterfly butterfly_1"></div>
                  <div class="butterfly butterfly_2"></div>
                  <div class="butterfly butterfly_3"></div>
                </div>
              </div>
              <div :class="'choose_box ' + (isOpenCore ? 'open_ani' : '')">
                <div class="choose_1">
                  <div class="choose_btn" @click="onApprentice()"></div>
                  <div class="choose_tips"></div>
                </div>
                <div class="choose_2">
                  <div class="choose_btn" @click="onRecruit()"></div>
                  <div class="choose_tips"></div>
                </div>
              </div>
              <div :class="'user_name_box ' + (isOpenCore ? 'fade_in_ani' : '')">
                <span class="user_name">
                  <b>{{ userInfo.role_id ? userInfo.role_name : '请登陆' }}</b>
                </span>
                <span v-if="!userInfo.role_id" class="operation_btn login_btn" @click="changeLoginPopup(true)">登陆</span>
                <span v-if="userInfo.role_id" class="operation_btn change_btn" @click="changeUser()">切换</span>
              </div>
              <!-- 核心页 -->
              <div :class="'core ' + (isOpenCore ? 'core_ani' : '')">
                <div class="core_inner" ref="coreInner">
                  <!-- 侧边栏 -->
                  <div class="sidebar">
                    <div class="circle"></div>
                    <div :class="'sidebar_item sidebar_1 ' + (tabIdx === 0 ? 'active' : '')" @click="changeActiveIdx(0)"></div>
                    <div :class="'sidebar_item sidebar_2 ' + (tabIdx === 1 ? 'active' : '')" @click="changeActiveIdx(1)"></div>
                    <div :class="'sidebar_item sidebar_3 ' + (tabIdx === 2 ? 'active' : '')" @click="changeActiveIdx(2)"></div>
                    <div class="square"></div>
                  </div>
                  <div class="core_right">
                    <!-- TAG: 任务大厅 -->
                    <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                      <div class="task_box" v-if="activeIdx === 0">
                        <!-- TAG: 人物形象 -->
                        <div class="figure">
                          <div class="role_box">
                            <div :class="'role-' + roleTypeName + '-' + roleSex"></div>
                            <div :class="'designation designation_' + roleTypeName"></div>
                            <div :class="'refresh_btn ' + ( takeStatus ? '' : 'refresh_stop')" @click="onRefresh('任务大厅')"></div>
                            <div class="info">
                              <div class="capability"><span>{{this.activeInfo.faq}}</span></div>
                              <div class="detail">
                                <div class="grade">{{this.activeInfo.player_lv}}</div>
                                <div class="name">{{this.userInfo.role_name}}</div>
                                <div :class="'sex sex-' + roleSex"></div>
                                <div class="login_out_btn" @click="clickLogout()">注销</div>
                              </div>
                              <div class="area_box">{{this.userInfo.server_name}}</div>
                            </div>
                            
                          </div>
                        </div>

                        <!-- TAG: 【徒弟】任务列表 -->
                        <div v-if="roleType === 1" class="take_layout">
                          <div :class="'take_list ' + (isLockTake ? 'lock_take ' : '') + (takeScroll ? 'take_scroll' : '')">
                            <ul :class="examineMove ? 'move' : ''" ref="examineList">
                              <transition v-for="(item, idx) in takeData" :key="idx + item.status"
                                :enter-active-class="'animated fadeInRight take_' + (idx + 1)"
                                :leave-active-class="'animated fadeOutRight take_' + (idx + 1)">
                                <li v-if="takeStatus">
                                  <div class="item">
                                    <div class="take_detail">
                                      <h3>{{item.name}}</h3>
                                      <p :class="'ask_' + item.id"><span>{{item.ask}}</span></p>
                                    </div>
                                    <div class="take_award">
                                      <div class="award award_1">
                                        <img :src="item.image" alt="">
                                      </div>
                                    </div>
                                    <div :class="'receive_btn btn_' + item.status" @click="completeTask(item)"></div>
                                  </div>
                                </li>
                              </transition>
                            </ul>
                          </div>
                          <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                            <div v-if="takeStatus">
                              <div v-if="examineMove && !isLockTake" class="top_arrow" @click="examineMove = false"></div>
                            </div>
                          </transition>
                          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                            <div v-if="takeStatus">
                              <div v-if="!examineMove && !isLockTake" class="bottom_arrow" @click="examineMove = true"></div>
                            </div>
                          </transition> -->
                        </div>

                        <!--  TAG: 【师傅】徒弟的考核任务 -->
                        <div v-if="roleType === 2" :class="'examine_box ' + (isLockTake ? 'lock_examine' : '')">
                          <transition enter-active-class="animated fadeInRight examine_list_ani"
                            leave-active-class="animated fadeOutRight examine_list_leave_ani">
                            <div v-if="takeStatus" class="examine_box">
                              <div class="examine_list">
                                <div class="examine_item" v-for="(item, idx) in prenticeTakeData" :key="idx">
                                  <div class="examine_detail">
                                    <h3>{{item.examine_name}}</h3>
                                    <p>{{item.examine_condition}}</p>
                                  </div>
                                  <div class="examine_award">
                                    <div class="award award_1"></div>
                                  </div>
                                  <div :class="'receive_btn btn_' + item.examine_get" @click="receiveScore(item)"></div>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>

                        <!-- TAG: 【徒弟 & 师傅】锁定面板遮罩 -->
                        <div v-if="isLockTake" @click="clickLock()">
                          <transition enter-active-class="animated fadeIn email_ani" leave-active-class="animated fadeOut">
                            <div :class="'lock_mask lock_' + this.roleTypeName" v-if="takeStatus"><span></span></div>
                          </transition>
                        </div>

                        <!-- TAG: 【徒弟 & 师傅】消息 -->
                        <transition enter-active-class="animated fadeInRight email_ani" leave-active-class="animated fadeOutRight">
                          <div v-if="takeStatus" class="email_box" @click.stop="openNewsPopup()">
                            <div class="email_icon">
                              <span v-if="activeInfo.notice">{{this.activeInfo.notice}}</span>
                            </div>
                            <div class="email_label"></div>
                            <div :class="'email_text email_' + roleTypeName"></div>
                            <div class="email_more_icon"></div>
                          </div>
                        </transition>
                      </div>
                    </transition>
                    <!-- TAG: 师徒关系 -->
                    <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                      <div class="mentoring_box task_box" v-if="activeIdx === 1">
                        <div class="figure">
                          <div class="role_box">
                            <div :class="'role-master-' + (this.masterInfo.sex || 'none')" @click="apprenticePopup()"></div>
                            <div v-if="this.masterInfo.sex" :class="'master_title ' + this.masterInfo.sex"></div>
                            <div :class="'refresh_btn ' + ( memberStatus ? '' : 'refresh_stop')" v-if="this.roleType === 2" @click="onRefresh('师徒关系')"></div>
                            <div class="info" v-if="this.masterInfo.sex">
                              <div class="capability"><span>{{this.masterInfo.faq}}</span></div>
                              <div class="detail">
                                <div class="grade">{{this.masterInfo.player_lv}}</div>
                                <div class="name">{{this.masterInfo.role_name}}</div>
                                <div :class="'sex sex-' + this.masterInfo.sex"></div>
                              </div>
                              <div class="area_box">{{this.masterInfo.server_name}}</div>
                            </div>
                          </div>
                        </div>

                        <!-- TAG:徒弟同门列表 -->
                        <div class="prentice_list">
                          <div class="prentice_list_box">
                            <div v-for="(item, idx) in prenticeData" :key="idx" class="item">
                              <div v-if="item.role_id">
                                <transition
                                  :enter-active-class="'animated fadeInRight prentice_' + (idx + 1)"
                                  :leave-active-class="'animated fadeOutRight prentice_leave_' + (idx + 1)">
                                  <div v-if="memberStatus" :class="'prentice prentice_' + item.sex" :data-idx="idx"
                                  @click="clickPrenticeInfo()">
                                    <div class="profile">
                                      <div class="level">{{item.player_lv}}</div>
                                      <div v-if="roleType === 1" :class="'tip ' + (item.isMyself ? 'my_tip' : '')"></div>
                                    </div>
                                    <div class="info">
                                      <div class="name">
                                        <b>{{item.role_name}}</b>
                                        <span>
                                          <div v-if="item.isMyself" class="more_icon" @click.stop="changeJudgeMasterShow()"></div>
                                          <div v-if="item.isMyself && judgeMasterShow" class="judge_master" @click.stop="onJudgeMaster()"></div>
                                          <div v-if="roleType === 2" class="more_icon" @click.stop="openExileTip(idx)"></div>
                                          <div v-if="roleType === 2 && exileTips[idx]" class="exile_tip" @click.stop="openExilePopup(item)"></div>
                                        </span>
                                      </div>
                                      <p class="area">{{item.server_name}}</p>
                                      <div class="capability"><span>{{item.faq}}</span></div>
                                    </div>
                                    <div class="designation"></div>
                                  </div>
                                </transition>
                              </div>
                              <div v-else>
                                <transition
                                  :enter-active-class="'animated fadeInRight prentice_' + (idx + 1)"
                                  :leave-active-class="'animated fadeOutRight prentice_leave_' + (idx + 1)">
                                  <div v-if="memberStatus" :class="'prentice prentice_none prentice_none_' + roleTypeName" :data-idx="idx">
                                    <div v-if="roleTypeName === 'master'" class="add_btn" @click="openAddPrenticePopup()"></div>
                                  </div>
                                </transition>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                    <!-- TAG: 商店&剑侠之路 -->
                    <transition
                      enter-active-class="animated fadeInRight store_designation_ani"
                      leave-active-class="animated fadeOutRight">
                      <div class="store_designation_box" v-if="activeIdx === 2">
                        <!-- <div class="slide">
                          <div :class="'slide_item slide_1 ' + (roleType === 1 && ' lock ') + (storeTabIdx === 1 && ' active')"
                            @click="changeStoreIdx(1)"></div>
                          <div :class="'slide_item slide_2 '  + (storeTabIdx === 0 ? ' active' : '')"
                            @click="changeStoreIdx(0)"></div>
                        </div> -->
                        <div class="store_box" v-show="storeIdx === 1">
                          <div class="merchant">
                            <transition
                              enter-active-class="animated fadeInRight merchant_role_ani"
                              leave-active-class="animated fadeOutRight merchant_role_ani">
                              <div v-if="commodityStatus" class="role"></div>
                            </transition>
                          </div>
                          <transition
                            enter-active-class="animated fadeInRight store_list_ani"
                            leave-active-class="animated fadeOutRight store_list_leave">
                            <div v-if="commodityStatus" class="store_list">
                              <ul class="commodity_list">
                                <transition v-for="(item, idx) in commodity" :key="item.id"
                                  :enter-active-class="'animated fadeIn commodity_ani commodity_ani_' + idx"
                                  :leave-active-class="'animated fadeOut commodity_ani commodity_leave_ani_' + idx">
                                  <li v-if="commodityStatus" :class="'commodity_' + (Number(idx))" @click="openMerchandisePopup(item)">
                                    <img :src="item.image" />
                                    <div class="coin_box">
                                      <b class="icon"></b>
                                      <span>{{ item.peach_value }}</span>
                                    </div>
                                    <div v-if="item.is_get" class="exchange"></div>
                                  </li>
                                </transition>
                              </ul>
                              <transition enter-active-class="animated fadeIn peach_blossom_ani" leave-active-class="animated fadeOut peach_blossom_leave_ani">
                                <div v-if="commodityStatus" class="peach_blossom_box"><span>{{this.activeInfo.peach_value || 0}}</span></div>
                              </transition>
                            </div>
                          </transition>
                        </div>
                        <div class="designation_box" v-show="storeIdx === 0">
                          <transition enter-active-class="animated fadeInUp branch_ani" leave-active-class="animated fadeOutDown">
                            <div v-if="knightErrantStatus" class="branch"></div>
                          </transition>
                          <transition enter-active-class="animated fadeInUp grow_award_ani" leave-active-class="animated fadeOutDown">
                            <div v-if="knightErrantStatus" class="grow_award_list">
                              <ul>
                                <li class="grow_award_1">
                                  <img v-if="rewardList[0]" src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_1.png" alt="">
                                  <img v-else src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_01.png" alt="">
                                  <span v-if="rewardList[0]" class="complete"></span>
                                </li>
                                <li class="grow_award_2">
                                  <img v-if="rewardList[1]" src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_2.png" alt="">
                                  <img v-else src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_02.png" alt="">
                                  <span v-if="rewardList[1]" class="complete"></span>
                                </li>
                                <li class="grow_award_3">
                                  <img v-if="rewardList[2]" src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_3.png" alt="">
                                  <img v-else src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_03.png" alt="">
                                  <span v-if="rewardList[2]" class="complete"></span>
                                </li>
                                <li class="grow_award_4">
                                  <img v-if="rewardList[3]" src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_4.png" alt="">
                                  <img v-else src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_04.png" alt="">
                                  <span v-if="rewardList[3]" class="complete"></span>
                                </li>
                                <li class="grow_award_5">
                                  <img v-if="rewardList[4]" src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_5.png" alt="">
                                  <img v-else src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_05.png" alt="">
                                  <span v-if="rewardList[4]" class="complete"></span>
                                </li>
                                <li class="grow_award_6">
                                  <img v-if="rewardList[5]" src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_6.png" alt="">
                                  <img v-else src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_06.png" alt="">
                                  <span v-if="rewardList[5]" class="complete"></span>
                                </li>
                                <li class="grow_award_7">
                                  <img v-if="rewardList[6]" src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_7.png" alt="">
                                  <img v-else src="../../../../assets/images/active/hjwq/mentoring/prentice/grow_award_07.png" alt="">
                                  <span v-if="rewardList[6]" class="complete"></span>
                                </li>
                              </ul>
                            </div>
                          </transition>
                          <transition enter-active-class="animated fadeInUp grow_value_ani" leave-active-class="animated fadeOutDown">
                            <div v-if="knightErrantStatus" class="grow_value_list">
                              <div :class="'grow_value_orange progress_' + completeRewardNum"></div>
                              <ul>
                                <li class="grow_value_1">
                                  <div :class="'flower ' + (rewardList[0] ? 'flower_orange' : '')"></div>
                                  <div :class="'grow_rate ' + (rewardList[0] ? 'grow_rate_orange' : '')">100</div>
                                </li>
                                <li class="grow_value_2">
                                  <div :class="'flower ' + (rewardList[1] ? 'flower_orange' : '')"></div>
                                  <div :class="'grow_rate ' + (rewardList[1] ? 'grow_rate_orange' : '')">200</div>
                                </li>
                                <li class="grow_value_3">
                                  <div :class="'flower ' + (rewardList[2] ? 'flower_orange' : '')"></div>
                                  <div :class="'grow_rate ' + (rewardList[2] ? 'grow_rate_orange' : '')">300</div>
                                </li>
                                <li class="grow_value_4">
                                  <div :class="'flower ' + (rewardList[3] ? 'flower_orange' : '')"></div>
                                  <div :class="'grow_rate ' + (rewardList[3] ? 'grow_rate_orange' : '')">400</div>
                                </li>
                                <li class="grow_value_5">
                                  <div :class="'flower ' + (rewardList[4] ? 'flower_orange' : '')"></div>
                                  <div :class="'grow_rate ' + (rewardList[4] ? 'grow_rate_orange' : '')">500</div>
                                </li>
                                <li class="grow_value_6">
                                  <div :class="'flower ' + (rewardList[5] ? 'flower_orange' : '')"></div>
                                  <div :class="'grow_rate ' + (rewardList[5] ? 'grow_rate_orange' : '')">600</div>
                                </li>
                                <li class="grow_value_7">
                                  <div :class="'flower ' + (rewardList[6] ? 'flower_orange' : '')"></div>
                                  <div :class="'grow_rate ' + (rewardList[6] ? 'grow_rate_orange' : '')">700</div>
                                </li>
                              </ul>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 收徒|拜师-弹窗 -->
        <div @touchmove.prevent class="popup_wrap apprentice-recruit-wrap" v-show="apprenticeRecruitShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="popup-wrap-box" v-show="apprenticeRecruitShow">
              <div :class="'title title_'+ apprenticeRecruitIdx"></div>
              <div class="left">
                <h3>{{this.apprenticeRecruitConfig[this.apprenticeRecruitIdx - 1][0]}}</h3>
                <div class="link_box">
                  <div class="link_input">
                    <span>{{this.apprenticeRecruitLink}}</span>
                  </div>
                  <div class="copy_btn"  @click="onCopy()" id="clipboard-btn" data-event="复制邀请链接"
                    :data-clipboard-text="apprenticeRecruitConfig[this.apprenticeRecruitIdx - 1][3] + apprenticeRecruitLink">复制</div>
                </div>
                <h3>{{this.apprenticeRecruitConfig[this.apprenticeRecruitIdx - 1][1]}}</h3>
                <div class="qrcode_box">
                  <div id="qrcode" class="qrcode"></div>
                </div>
              </div>
              <div class="right">
                <h3>{{this.apprenticeRecruitConfig[this.apprenticeRecruitIdx - 1][2]}}</h3>
                <div class="role_id_query">
                  <div class="input_box">
                    <input type="text" v-model="roleIdInput">
                  </div>
                  <div class="query_btn" @click="queryRoleInfo()">查询</div>
                </div>
                <div class="query_result_box">
                  <div class="none" v-if="!findRoleInfo">请在上方输入ID查找</div>
                  <div class="none" v-else-if="!findRoleInfo.role_id">查无此人</div>
                  <div :class="'role_info role_info_' + findRoleInfo.sex" v-else>
                    <div class="profile">
                      <div class="level">{{this.findRoleInfo.player_lv}}</div>
                    </div>
                    <div class="info">
                      <div class="name">
                        <b>{{this.findRoleInfo.role_name}}</b>
                        <span></span>
                      </div>
                      <p class="area">{{this.findRoleInfo.server_name}}</p>
                      <div class="capability"><span>{{this.findRoleInfo.faq}}</span></div>
                    </div>
                  </div>
                  <div :class="'operation_btn btn_' + apprenticeRecruitIdx" v-if="findRoleInfo && findRoleInfo.role_id">
                    <span @click="onApprenticeRecruit()"></span>
                  </div>
                </div>
              </div>
              <div class="close_btn" @click="apprenticeRecruitShow=false"></div>
            </div>
          </transition>
        </div>
        <!-- 新闻-弹窗 -->
        <div class="popup_wrap news-wrap" v-show="newsShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="popup-wrap-box" v-show="newsShow">
              <div class="news" v-if="news.length">
                <div v-for="(item, idx) in news" :key="idx" class="new_item">
                  <div :class="'role_info role_info_' + item.aoth_info.sex">
                    <div class="profile">
                      <div class="level">{{item.aoth_info.player_lv}}</div>
                    </div>
                    <div class="info">
                      <div class="name">
                        <b>{{item.aoth_info.role_name}}</b>
                        <span></span>
                      </div>
                      <p class="area">{{item.aoth_info.server_name}}</p>
                      <div class="capability"><span>{{item.aoth_info.faq}}</span></div>
                    </div>
                  </div>
                  <div class="operation">
                    <div class="btn recruit_btn" @click="onRecruitRefuse(item.id, 1)"></div>
                    <div class="btn refuse_btn" @click="onRecruitRefuse(item.id, 2)"></div>
                  </div>
                </div>
              </div>
              <div v-else class="news_none">暂无申请</div>
              <div class="close_btn" @click="closeNewsPopup()"></div>
            </div>
          </transition>
        </div>
        <!-- 商品兑换-弹窗 -->
        <div class="popup_wrap merchandise-wrap" v-show="merchandiseShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="popup-wrap-box" v-show="merchandiseShow">
              <div class="intro">
                <div>是否消耗<span>【{{this.curMerchandise.peach_value}}桃李值】</span>兑换 {{this.curMerchandise.name}}？</div>
              </div>
              <div class="btn btn_1" @click="onExchange()"></div>
              <div class="btn btn_2" @click="closeMerchandisePopup()"></div>
            </div>
          </transition>
        </div>
        <!-- 判出师门|逐出师门 -弹窗 -->
        <div class="popup_wrap betrayal-exile-wrap" v-show="betrayalExileShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="popup-wrap-box" v-show="betrayalExileShow">
              <div :class="'title title_' + betrayalExileIdx"></div>
              <div class="intro">
                <div v-if="betrayalExileIdx === 1">确定与师尊<span>【{{this.masterInfo.role_name}}】</span> 解除师徒关系？</div>
                <div v-if="betrayalExileIdx === 2">确定与徒弟<span>【{{this.exilePrentice.role_name}}】</span> 解除师徒关系？</div>
              </div>
              <div class="btn btn_1" @click="onBetrayalExileHandle()"></div>
              <div class="btn btn_2" @click="closeBetrayalExilePopup()"></div>
            </div>
          </transition>
        </div>
        <!-- 任务大厅 注销 -->
        <div class="popup_wrap logout-wrap" v-show="logoutShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="popup-wrap-box" v-show="logoutShow">
              <div class="btn btn_1" @click="customizeLogout()"></div>
              <div class="btn btn_2" @click="logoutShow = false"></div>
            </div>
          </transition>
        </div>
      </div>
      <!-- 登陆模块 -->
      <Login v-if="isShowLogin"
        v-on:channelCallback="selectCallback"
        :gameName="gameName"
        :loginTypes="loginTypes"
        downloadUrl="https://static.qcplay.com/tideng/official/"
        channelTips="UID可在游戏中—设置—UID查看"></Login>
      <Os
        v-if="isShowOs"
        v-on:selectCallback="selectCallback"
        v-on:logoutCallback="osCancell"
        :gameName="gameName"></Os>
    </div>
  </div>

</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import Os from '@/components/os';
import Login from '@/components/login';
import { mapState, mapMutations, mapActions } from 'vuex';
import { onGetInitDataAPI, getShopListAPI, getNewListAPI, onCheckNoticeAPI,
  onMasterListAPI, onExchangeAPI, findRoleInfoAPI, sendCheckStore, getExaminesAPI,
  onReceiveScoreAPI, onRenovateAPI, completeTakeAPI, onBetrayAPI, onDriveAPI } from '../api';
import { getHtmlFontSize, buriedLogger } from '@/utils/utils';
import { generateQRCode } from '@/utils/share';
import { generateSortLink } from '@/api/active';
import { LogoutAPI } from '@/api/login';

const SCALE_RATIO = {
  '1.7': 0.95,
  '1.6': 0.9,
  '1.55': 0.85,
  '1.46': 0.8,
  '1.39': 0.75,
  '1.31': 0.7
};

export default {
  name: 'mentoring_index',
  components: {
    Login,
    Os
  },
  data () {
    return {
      gameName: 'hjwq',
      logger: null,
      loginTypes: ['sms', 'password'],

      homeShow: false,
      isOpenCore: false,
      tabIdx: null, // 左侧侧边栏高亮索引
      activeIdx: null, // 右侧活跃模块索引
      storeTabIdx: 0,
      storeIdx: 0, // 0:剑侠之路  1：桃李商店
      takeStatus: false, // 任务大厅 任务列表动画状态
      memberStatus: false, // 师门关系 成员动画状态
      commoditySwitching: false,
      commodityStatus: false, // 桃李商店 商品动画状态
      knightErrantStatus: false,
      sliderSwitching: false,
      apprenticeRecruitShow: false, // 收徒拜师弹窗
      apprenticeRecruitIdx: 2, // 1: 拜师  2： 收徒
      apprenticeRecruitConfig: [
        ['一、发送链接给好友拜师', '二、截图二维码发送给好友拜师', '三、搜索游戏ID拜师',
          '【新仙剑】仙师请收我为徒，能劈柴、能做饭，只为踏上仙途，成当世豪侠！点击链接收我为徒吧：'],
        ['一、发送链接给好友收徒', '二、截图二维码发送给好友收徒', '三、搜索游戏ID收徒',
          '【新仙剑】少侠我看你根骨奇异，是万中无一练剑的好苗子。我这里有几本剑谱，你可愿意拜我为师？点击链接前往拜师界面：']
      ],
      apprenticeRecruitLink: '',
      roleIdInput: '',
      findRoleInfo: {}, // 查询角色
      newsShow: false, // 消息弹窗
      news: [], // 消息列表
      merchandiseShow: false,
      curMerchandise: {},
      betrayalExileShow: false,
      betrayalExileIdx: 2, // 1: 判出师门  2： 逐出师门
      exilePrentice: {},
      exileTips: [false, false, false],
      logoutShow: false, // 注销弹窗
      examineMove: false, // 是否移动考核列表
      takeScroll: false, // 显示徒弟任务下拉效果

      roleType: 0, // 当前角色身份 1: 徒弟  2: 师傅
      roleTypeName: '', // 1: prentice[徒弟]  2: master[师傅]
      roleSex: '', // 当前角色 性别 boy  girl
      isLockTake: false, // 是否锁定任务列表
      judgeMasterShow: false,

      // 数据
      masterInfo: {}, // 师傅信息
      takeData: [], // 任务信息
      prenticeData: [], // 徒弟列表
      commodity: [], // 商品列表
      prenticeTakeData: [],
      rewardList: [], // 剑侠之路完成度
      completeRewardNum: 0,
    };
  },
  created () {
    // // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    setTimeout(() => {
      this.getLoginContainer();
    }, 100);

    // 监控埋点
    const bl = buriedLogger('hjwq', 'mentoring_index_page');
    this.logger = bl;
  },
  mounted () {
    this.$nextTick(() => {
      this.forceLandscapeScreenHandle();
      
      this.onWindowSizeChanged();
    });
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.cleanData();
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候 赋予用户相关数据
          const { sex, master_info = {}, is_master, task_list, solider_info = [], code, reward_list = [], status } = this.activeInfo;
          const roleType = Number(status);
          const roleTypeName = roleType === 1 ? 'prentice' : 'master';
          this.roleType = roleType;
          this.roleTypeName = roleTypeName;
          this.roleSex = sex;
          this.rewardList = reward_list;
          this.completeRewardNum = reward_list.filter(item => item !== 0).length;
          // 确定剑侠之路
          this.storeIdx = roleType - 1;
          if (roleType === 1) {
            this.masterInfo = master_info;
            this.isLockTake = !is_master;
            // 同门信息
            const defaultPrentices = Array.from(new Array(3), () => ({}));
            solider_info.forEach((item) => {
              item.isMyself = item.role_id === newValue.role_id;
            });
            this.prenticeData = solider_info.concat(defaultPrentices).splice(0, 3);

            this.takeData = task_list || [];
          } else {
            this.masterInfo = master_info;
            this.getMasterList();
          }
          // 分享相关
          const { protocol, host } = window.location;
          const apprenticeRecruitLink = `${protocol}//${host}/hjwq/mentoring/invitationLetter?type=${
            roleType}&code=${code}&user_id=${newValue.user_id}`;
          generateSortLink(apprenticeRecruitLink).then((response) => {
            this.apprenticeRecruitLink = `https://${response.data.uri}`;
            this.qrcode(`https://${response.data.uri}`);
          });
          
        }
      }
    },
  },
  methods: {
    // 适配
    forceLandscapeScreenHandle () {
      if (document.activeElement.nodeName === 'INPUT') return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
          fontH = (window.innerWidth > window.innerHeight) ? height : width;

      const el = document.getElementById('home-page');
      let style = '';
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${width / 2}px center;width:${height}px;height:${width}px`;
        document.getElementsByTagName('body')[0].className = 'portrait';
        this.homeShow = true;
      } else {
        // 横板        
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + 'px';
          style = `transform:rotate(0deg);transform-origin:${width / 2}px center;width:${width}px;height:${height}px`;
          document.getElementsByTagName('body')[0].className = '';
          this.homeShow = true;
          if (el) el.style = style;
        }, 300);
      }
      if (el) el.style = style;

      this.scaleCoreBox();
    },
    // 核心玩法区域缩放
    scaleCoreBox() {
      let curScale = 1;
      const clientWidth = document.documentElement.clientWidth;
      const clientHeight = document.documentElement.clientHeight;
      const width = clientWidth > clientHeight ? clientWidth : clientHeight;
      const height = clientWidth > clientHeight ? clientHeight : clientWidth;
      const aspectRatio = Number((width / height).toFixed(3));
      for (let key in SCALE_RATIO) {
        if (Number(key) >= aspectRatio) {
          curScale = SCALE_RATIO[key];
        } else {
          break;
        }
      }
      this.$refs.coreInner.style = `transform: scale(${curScale});`;
    },
    onWindowSizeChanged () {
      window.addEventListener('resize', this.forceLandscapeScreenHandle);
    },
    isReloadWindow (event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance && window.performance.navigation && window.performance.navigation.type === 2))
      );
    },
    // 初始化/更新用户活动信息
    getLoginContainer (needUpdate = false) {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        if (needUpdate) {
          this.updateRoleInfoByInit(response.data.user_info, response.data.activity);
        }
        // this.preloadingShow = false;
      });
    },
    updateRoleInfoByInit (userInfo, activeInfo) {
      const { master_info = {}, is_master, task_list, solider_info = [], reward_list = [] } = activeInfo;
      this.rewardList = reward_list;
      this.completeRewardNum = reward_list.filter(item => item !== 0).length;
      if (this.roleType === 1) {
        this.masterInfo = master_info;
        this.isLockTake = !is_master;
        // 同门信息
        const defaultPrentices = Array.from(new Array(3), () => ({}));
        solider_info.forEach((item) => {
          item.isMyself = item.role_id === userInfo.role_id;
        });
        this.prenticeData = solider_info.concat(defaultPrentices).splice(0, 3);

        this.takeData = task_list || [];
      } else {
        this.masterInfo = master_info;
        this.getMasterList();
      }
    },
    qrcode (link) {
      const fontSize = getHtmlFontSize();
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        width:  2 * fontSize,
        height: 2 * fontSize,
        colorDark: '#ffffff',
        colorLight: '#000000'
      });
    },
    onCopy () {
      const clipboard = new Clipboard('#clipboard-btn');
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });

      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
      // this.logger.sum('anniversary_copy_link');
    },
    getShopListReward () {
      getShopListAPI().then((response) => {
        this.commodity = response.data.shop_list || [];
      });
    },
    changeUser () {
      this.changeOsPopup(true);
    },
    selectCallback () {
      this.getLoginContainer();
    },
    osCancell () {
      // 清空数据
    },
    cleanData () {
      // TODO:清理状态
      this.examineMove = false;
      // 清空数据
      this.masterInfo = {};
      this.takeData = [];
      this.prenticeData = [];
      this.commodity = [];
      this.prenticeTakeData = [];
      this.rewardList = [];
      this.completeRewardNum = 0;
    },
    // TAG: 业务事件
    // 获取师门信息
    getMasterList () {
      onMasterListAPI().then((response) => {
        const solider_info = response.data.solider_info || [];
        const isLock = response.data.is_master_lock;
        const defaultPrentices = Array.from(new Array(3), () => ({}));
        this.isLockTake = isLock;
        this.prenticeData = solider_info.concat(defaultPrentices).splice(0, 3);
        if (!isLock) {
          getExaminesAPI().then((response) => {
            this.prenticeTakeData = response.data.examine_list || [];
          });
        } else {
          this.prenticeTakeData = this.activeInfo.examine_list || [];
        }
      });
      this.getShopListReward();
    },
    // 拜师
    onApprentice () {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      const { status } = this.activeInfo;
      if (Number(status) !== 1) {
        this.onToast('请前往收徒');
        return false;
      }
      this.openCore();
      this.logger.sum('首屏_我要拜师');
    },
    // 收徒
    onRecruit () {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      const { status } = this.activeInfo;
      if (Number(status) !== 2) {
        this.onToast('请前往拜师');
        return false;
      }
      this.openCore();
      this.logger.sum('首屏_我要收徒');
    },
    openCore () {
      this.isOpenCore = true;
      setTimeout(() => {
        this.tabIdx = 0;
        this.activeIdx = 0;
        setTimeout(() => {
          this.takeStatus= true;
          this.onTakeScroll();
        }, 500)
        
      }, 1000);
    },
    // 个人人物形象处的退出
    clickLogout() {
      this.logoutShow = true;
      this.logger.sum('任务大厅_退出');
    },
    customizeLogout () {
      Indicator.open();
      LogoutAPI({ game_id: this.userInfo.game_id })
        .then(() => {
          this.logoutShow = false;
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.logoutAni();
          setTimeout(() => {
            this.changeLoginPopup(true);
          }, 2000);
        })
        .finally(() => Indicator.close());
    },
    logoutAni() {
      this.takeStatus= false;
      this.takeScroll = false;
      setTimeout(() => {
        this.tabIdx = null;
        this.activeIdx = null;
      }, 500);
      setTimeout(() => {
        this.isOpenCore = false;
      }, 1000);
    },
    onTakeScroll () {
      if (!this.$refs.examineList) {
        return false;
      }
      setTimeout(() => {
        this.takeScroll = true;
        this.$refs.examineList.addEventListener('scroll', (even) => {
          const { scrollTop, scrollHeight } = even.target;
          const rotate = Number((scrollTop / scrollHeight * 100).toFixed(2));
          if (rotate > 32) {
            this.takeScroll = false;
          } else {
            this.takeScroll = true;
          }
        });
      }, 1000);

    },
    changeActiveIdx (idx) {
      if (idx === this.activeIdx || this.sliderSwitching) {
        return false;
      }
      const eventHandle = [
        {
          enter: () => {
            this.takeStatus = true;
            this.onTakeScroll();
          },
          leave: () => {
            this.takeStatus = false;
            this.takeScroll = false;
          }
        },
        {
          enter: () => { this.memberStatus = true; },
          leave: () => { this.memberStatus = false; },
        },
        {
          enter: () => {
            if (this.storeIdx === 0) {
              this.knightErrantStatus = true;
            } else {
              this.commodityStatus = true; 
            }
          },
          leave: () => {
            if (this.storeIdx === 0) {
              this.knightErrantStatus = false;
            } else {
              this.commodityStatus = false; 
            }
          },
        }
      ];
      // 左侧侧边栏先切换，禁止切换状态打开(防止动画未播完，进行切换)
      this.tabIdx = idx;
      this.sliderSwitching = true;

      // 旧模块的子模块淡出动画效果 -> 旧模块淡出+选中模块渐入 -> 选中模块的子模块淡入 -> 禁止切换状态关闭
      eventHandle[this.activeIdx].leave();
      setTimeout(() => { this.activeIdx = idx; }, 700);
      setTimeout(() => { eventHandle[idx].enter(); }, 800);
      setTimeout(() => { this.sliderSwitching = false; }, 2000);

      //埋点
      const tabNames = ['任务大厅', '师门关系', '桃李商店'];
      this.logger.sum(tabNames[idx]);
    },
    changeStoreIdx (idx) {
      if (idx === this.storeIdx || this.commoditySwitching) {
        return false;
      }
      if (this.roleType === 1 && idx === 1) {
        this.onToast('出师后可解锁商店兑换');
        return false;
      }
      this.storeTabIdx = idx;
      this.commoditySwitching = true;
      if (idx === 0) {
        this.commodityStatus = false;
      } else {
        this.knightErrantStatus = false;
      }
      setTimeout(() => { this.storeIdx = idx; }, 700);
      setTimeout(() => {
        if (idx === 0) {
          this.knightErrantStatus = true;
        } else {
          this.commodityStatus = true;
        }
      }, 750);
      setTimeout(() => { this.commoditySwitching = false; }, 2000);
      const tabNames = ['剑侠之路', '桃李商店2'];
      this.logger.sum(tabNames[idx]);
    },
    // 打开添加徒弟弹窗
    openAddPrenticePopup () {
      this.recruitPopup();
      this.logger.sum('添加徒弟');
    },
    // 打开判出师门
    changeJudgeMasterShow () {
      this.judgeMasterShow = !this.judgeMasterShow;
    },
    onJudgeMaster () {
      this.judgeMasterShow = false;
      this.betrayalExileIdx = 1;
      this.betrayalExileShow = true;
    },
    openNewsPopup () {
      Indicator.open();
      getNewListAPI()
        .then((response) => {
          this.news = response.data.list || [];
          this.newsShow = true;
        })
        .finally(() => Indicator.close());
      this.logger.sum('打开消息');
    },
    closeNewsPopup () {
      this.newsShow = false;
      this.getLoginContainer(true);
    },
    openMerchandisePopup (info) {
      if (Number(this.activeInfo.peach_value || 0) < Number(info.peach_value)) {
        this.onToast('桃李值不足');
        return false;
      }
      if (info.is_get === 1) {
        return false;
      }
      this.curMerchandise = info;
      this.merchandiseShow = true;
      this.logger.sum(`点击商品[${info.name}]`);
    },
    closeMerchandisePopup () {
      this.curMerchandise = {};
      this.merchandiseShow = false;
    },
    onExchange () {
      Indicator.open();
      onExchangeAPI({ id: this.curMerchandise.id }).then(() => {
        this.onToast('兑换成功');
        this.getShopListReward();
        this.closeMerchandisePopup();
        this.getLoginContainer(true);
      }).finally(() => Indicator.close());
    },
    onRecruitRefuse (id, status) {
      Indicator.open();
      onCheckNoticeAPI({ id, status })
        .then((response) => {
          getNewListAPI().then((resp) => {
            this.news = resp.data.list || [];
          });
          this.onToast(response.message);
        })
        .finally(() => Indicator.close());
    },
    // 拜师弹窗
    apprenticePopup () {
      if (this.roleType === 1 && !this.masterInfo.id) {
        this.findRoleInfo = null;
        this.apprenticeRecruitIdx = 1;
        this.apprenticeRecruitShow = true;
      }
      this.logger.sum('拜师弹窗');
    },
    // 收徒弹窗
    recruitPopup () {
      this.findRoleInfo = null;
      this.apprenticeRecruitIdx = 2;
      this.apprenticeRecruitShow = true;
      this.logger.sum('收徒弹窗');
    },
    // 通过id查询用户信息
    queryRoleInfo () {
      if (!this.roleIdInput) {
        this.onToast('请输入角色ID');
        return false;
      }
      Indicator.open();
      findRoleInfoAPI({ id: this.roleIdInput })
        .then((response) => {
          this.findRoleInfo = response.data.info;
        })
        .catch(({ code }) => {
          this.findRoleInfo = {};
        })
        .finally(() => Indicator.close());
      const typeName = { 1: '拜师',  2: '收徒' }[this.onApprenticeRecruit];
      this.logger.sum(`查询角色[${typeName}]`);
    },
    // 查询完用户 拜师或者收徒
    onApprenticeRecruit () {
      const typeName = { 1: '拜师',  2: '收徒' }[this.onApprenticeRecruit];
      if (this.findRoleInfo && this.findRoleInfo.role_id) {
        sendCheckStore({ ...this.findRoleInfo }).then((response) => {
          // const typeName = { 1: '拜师',  2: '收徒' }[this.onApprenticeRecruit];
          this.onToast('请求已发送,快去通知好友！');
          // if (response.data.count === 9) {
          //   this.getLoginContainer(true);
          // }
        });
      } else {
        this.onToast('请先查询用户');
      }
      this.logger.sum(`查询角色操作[${typeName}]`);
    },
    // 领取桃李值
    receiveScore(item) {
      if (item.examine_get !== 1) { // 1的时候才能领取
        return false;
      }
      Indicator.open();
      onReceiveScoreAPI({
        examine_id: item.examine_id,
      }).then((response) => {
        this.onToast(response.message);
        getExaminesAPI().then((response) => {
          this.prenticeTakeData = response.data.examine_list || [];
        })
      }).finally(() => Indicator.close());
      this.logger.sum('领取桃李值');
    },
    // 打开 逐出师门 弹窗
    openExilePopup (info) {
      this.betrayalExileIdx = 2;
      this.exilePrentice = info;
      this.betrayalExileShow = true;
      this.exileTips = [false, false, false];
      this.logger.sum('打开逐出师门弹窗');
    },
    closeBetrayalExilePopup () {
      this.betrayalExileShow = false;
      this.betrayalExileIdx = 0;
      this.exilePrentice = {};
    },
    // 打开逐出师门
    openExileTip(idx) {
      const exileTips = [false, false, false];
      if (!this.exileTips[idx]) {
        exileTips[idx] = true;
      }
      this.exileTips = exileTips;
    },
    // 点击徒弟信息
    clickPrenticeInfo () {
      this.exileTips = [false, false, false];
      this.judgeMasterShow = false;
    },
    onBetrayalExileHandle () {
      if (this.betrayalExileIdx === 1) {
        this.onBetrayal();
      } else {
        this.onExile();
      }
    },
    clickLock () {
      this.onToast('请前往师门关系进行拜师/收徒');
    },
    // 判出师门
    onBetrayal() {
      Indicator.open();
      onBetrayAPI({ master_id: this.masterInfo.id })
        .then((response) => {
          this.betrayalExileShow = false;
          this.onToast({
            duration: 3000,
            message: '判出师门成功，页面即将重新加载..'
          });
          setTimeout(() => { window.location.reload(); }, 3100);
        })
        .finally(() => Indicator.close());
    },
    // 逐出师门
    onExile() {
      Indicator.open();
      onDriveAPI({ solider_id: this.exilePrentice.id })
        .then((response) => {
          this.betrayalExileShow = false;
          this.onToast('逐出师门成功');
          this.getMasterList();
        })
        .finally(() => Indicator.close());
    },
    // 刷新
    onRefresh (name) {
      Indicator.open();
      onRenovateAPI()
        .then(() => {
          this.onToast('刷新完成');
          this.getLoginContainer(true);
        })
        .finally(() => Indicator.close());
      this.logger.sum(`刷新_${name}`);
    },
    // 徒弟领取每日奖励
    completeTask (take) {
      if (take.status !== 1) {
        return false;
      }
      Indicator.open();
      completeTakeAPI({ task_id: take.id })
        .then((response) => {
          this.onToast(response.message);
          if (response.data.count === 7) {
            this.onToast({
              duration: 3000,
              message: '恭喜您成功出师，页面即将重新加载...'
            });
            setTimeout(() => { window.location.reload(); }, 3100);
          } else {
            this.getLoginContainer(true);
          }
        })
        .finally(() => Indicator.close());
      this.logger.sum(`领取每日奖励_${take.name}`);
    },
    changeExamineMove(val) {
      this.examineMove = val;
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      let curConfig = {
        duration: 1000,
        className: 'toasts rotate'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      } else {
        curConfig = {
          ...curConfig,
          ...config
        }
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'setUserInfo',
      'setInitUserInfo',
      'confirmLogout',
      'setInitActiveInfo',
      'changeLoginPopup',
      'changeOsPopup'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/mentoring/Index/index.vue